<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Introduce Yourself</h1>
      </div>
    </div>
    <div id="form4" autocomplete="off">
      <div class="pt-20 row Introduce-yourself-container">
          <input type="hidden" name="user_id" id="user_id" disabled>
          <!--name-->
          <div class="row"> 
              <div class="col-sm-4 col-md-4">
                  <span>First Name</span>
                  <input type="text" class="" name="">
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Middle Name</span>
                  <input type="text" class="" name="">
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Last Name</span>
                  <input type="text" class="" name="">
              </div>
          </div>
          <!--birth and address-->
          <div class="row pt-10">
              <div class="col-sm-4 col-md-4">
                  <span>Date of birth</span>
                  <div class="ps-relative">
                    <input type="date" class="" name="">
                  </div>
              </div>
              <div class="col-sm-8 col-md-8">
                  <span>Email address</span>
                  <div class="ps-relative">
                      <input type="text" name="email" id="emailname" class="" required="" autofocus="">
                      <button type="button" class="validate-btn" id="verify_email_button">
                          validate
                      </button>
                  </div>
                  <label id="email-error" class="error" for="email"></label>

              </div>
          </div>
          <!--mobile and email-address-->
          <div class="row pt-10">
              <div class="col-sm-6 col-md-6">
                  <span>Mobile Number</span>
                  <div class="ps-relative">
                      <input type="text" name="mobile_no" id="mobile_no" class="" required="" autofocus="">
                      <button type="button"  class="validate-btn" id="verify_mobile_button"
                              onclick="$('.phone-tips').removeClass('none');$('.layer-container .mobile-verify').removeClass('none');">
                          validate
                      </button>
                  </div>
                  <label id="phone-error" class="error" for="phone"></label>
              </div>
          </div>
          <!--password-->
          <div class="row pt-10">
              <div class="col-sm-6 col-md-6">
                  <span>Create Password</span>
                  <input type="password" name="password" id="password" class="" required="" autofocus="">
              </div>
              <div class="col-sm-6 col-md-6">
                  <span>Confirm Password</span>
                  <input type="password" name="confirmPassword" class="" required="" autofocus="">
              </div>
          </div>
          <div class="reason-info pt-10">
              <p style="text-align: left;font-size: 20px">Are you an Australian Citizen or Permanent
                  Resident?</p>

              <div class="reason-btn-list" style="text-align: left">
                  <div class="toggle">
                      <input type="radio" name="is_australian_citizen" value="1"
                              id="australian_citizen_yes" required="" @click="showPR()">
                      <label class="default reason-btn-yes" for="australian_citizen_yes">Yes</label>
                      <input type="radio" name="is_australian_citizen" value="0"
                              id="australian_citizen_no" required="" @click="hidePR()">
                      <label class="default reason-btn-no" for="australian_citizen_no">No</label>
                  </div>
                  <label id="is_australian_citizen-error" class="error" for="is_australian_citizen"></label>
              </div>
          </div>
          <div class="citizen-info none">
              <!--card-number-->
              <div class="row pt-10">
                  <div class="col-sm-12 col-md-4">
                      <span>Medicare Card Number</span>
                      <input type="text" name="medicare_card_number" class="" required="" autofocus="">
                  </div>
                  <div class="col-sm-8 col-md-4">
                      <span>Reference Number</span>
                      <input type="text" name="medicare_reference_number" class="" required="" autofocus="">
                  </div>
                  <div class="col-sm-4 col-md-4">
                      <span>Card Colour</span>
                      <select name="medicare_card_colour" id="medicare_card_colour" required>
                          <option selected="selected" value="">Please Specify</option>
                          <option value="G">Green</option>
                          <option value="B">Blue</option>
                          <option value="Y">Yellow</option>
                      </select>
                  </div>
              </div>
              <!--Medicare Middle Name Valid To Date-->
              <div class="row pt-10">
                  <div class="col-sm-12 col-md-4">
                      <span>Medicare Middle Name</span>
                      <input type="text" name="medicareMiddleName" class="" autofocus="">
                  </div>
                  <div class="col-sm-8 col-md-4">
                      <span>Valid To Date</span>
                      <input id="medicare_valid_date" class="form-control" required="required" data-inputmask="'alias': 'date'" name="medicare_valid_date" type="text" value="" im-insert="false">
                  </div>
                  <div class="col-sm-4 col-md-4">
                      <span>Gender</span>
                      <select name="gender" id="gender" required>
                          <option selected="selected" value="">Please Specify</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                      </select>
                  </div>
              </div>
          </div>
      </div>


      <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('loan-term')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('connect-to-bank')">CONTINUE</a>
      </div>
      <hr style="margin-bottom: calc(10% + 40px); border: none">
    </div>
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    showPR(){$(".citizen-info").removeClass("none");},
    hidePR(){$(".citizen-info").addClass("none");},
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
